<template>
  <v-app>
    <div class="d-none d-md-block">
      <menu-chess></menu-chess>
    </div>
    <div class="d-md-none">
      <menu-chess-mobile></menu-chess-mobile>
    </div>
    <v-main>
      <v-container fluid>
        <div style="font-family: Noto Sand">
          <slot></slot>
        </div>
      </v-container>
    </v-main>
  </v-app>
</template>


<script>
import MenuChess from './MenuChess'
import MenuChessMobile from './MenuChessMobile'
//import { mapState } from 'vuex';
export default {
  name: "BasePage",
  components: {
    MenuChess, MenuChessMobile
  },
  beforeCreate() {
    this.$store.dispatch('fetchIsAuthenticated');
  },
  computed: {
    //...mapState(['noti']),
  },
  data(){
    return {
      openNoti: false
    }
  },
  methods: {
    close(){
      //this.$store.dispatch('addNoti',"");
      this.openNoti = false;
    }
  },
  watch: {
    'noti'(val){
      if (val) {
        this.openNoti = true;
      }
    }
  }
}
</script>

<style>
#app {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

#content-container {
  flex-grow: 1;
  margin-bottom: 20px; /* Ajusta la cantidad de margen inferior deseada */
}
.footer-m {

}
</style>